<template>
    <div class="index" :class="JoinShow ? 'OverFlow' : 'Scroll' ">
        <!-- 头部导航组件 -->
        <navbar-header></navbar-header>
        
        <swiper-img></swiper-img>

        <!-- 按钮和头条 -->
        <div class="swiperbox">
             <!-- 按钮列表 -->
            <!-- <menu-list :SwiperList="SwiperList" @showJoin="getShow"></menu-list> -->

            <!-- 头条 -->
            <swiper-news :TouTiao="TouTiao"></swiper-news>
        </div>

        <!--新闻列表组件 -->
        <div class="news_list_box">
            <div class="left">
                <news-list cateName="新闻动态" :cateId="282" :size="9" :showIcon="true" :isPoster="true"  ></news-list>
            </div>
            <div class="right">
                <news-list cateName="通知公告" :cateId="1" :size="5" :isPoster="false" ></news-list>
                <news-list cateName="基层工会" :cateId="283" :size="5" :isPoster="false" ></news-list>
            </div>
        </div>

        <!-- 图片列表 -->
        <!-- <img-list></img-list> -->

        <!-- 活动列表 -->
        <!-- <div class="news_list_box">
            <news-list cateName="教工风采" :cateId="225" :size="5" :isPoster="false" ></news-list>
            <news-list cateName="教工活动" :cateId="186" :size="5" :isPoster="false" ></news-list>
        </div> -->
        <!-- <div class="active_list">
            <active-list name="教工风采" :id="1" :index="0" ></active-list>
            <active-list name="教工活动" :id="4" :index="1"></active-list>
        </div> -->

        <!-- 红色学堂 -->
        <!-- <red-school></red-school> -->

        <!-- 单张图片 -->
        <!-- <div class="img_box">
            <a :href="imgObj.ads_link">
                <img :src="imgObj.ads_img" v-if="imgObj.ads_img && imgObj.ads_img.indexOf('http') != -1" alt="">
                <img :src="$ImgUrl + imgObj.ads_img" v-if="imgObj.ads_img && imgObj.ads_img.indexOf('http') == -1" alt="">
            </a>
        </div> -->

        <!-- 荣誉展示 -->
        <!-- <dang-yuan-show ></dang-yuan-show> -->

        <!-- 活动风采 -->
        <active-style></active-style>

        <!-- 友情链接 -->
        <friend-link></friend-link>

        <!-- 底部 -->
        <nav-footer></nav-footer>

        <!-- 入党dialog -->
          <div class="dialog_model" v-if="JoinShow">
            <div class="dialog_box">
                <div class="dialog_title">
                    <div class="left">
                        我要入会
                    </div>
                    <div class="right" @click="cancelShenBao">
                        <span class="el-icon-close"></span>
                    </div>
                </div>
                <div class="form_box">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="接收组织">
                            <el-select v-model="deptId" placeholder="请选择组织" @change="deptChange" >
                                <el-option
                                
                                v-for="item in AllDeptList"
                                :key="item.deptId"
                                :label="item.deptName"
                                :value="item.deptId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="*姓名" prop="pass">
                            <el-input type="text" v-model="formData.userName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*性别" prop="pass">
                            <el-select v-model="formData.sex">
                                <el-option v-for="(item, index) in sexList" :key="index" :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="*手机号码" prop="pass">
                            <el-input type="text" maxlength="11" v-model.number="formData.phone" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*学历" prop="pass">
                            <el-select v-model="formData.xueLi">
                                <el-option v-for="(item, index) in xue" :key="index" :label="item.dictName" :value="item.dictValue"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="*民族" prop="pass">
                            <el-select v-model="formData.minZu">
                                <el-option v-for="(item, index) in mz" :key="index" :label="item.mzName" :value="item.mzId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="*身份证" prop="pass">
                            <el-input type="text" maxlength="18" v-model="formData.idNumber" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*出生日期" prop="pass">
                            <el-input type="text" v-model="formData.birthday" autocomplete="off" disabled></el-input>
                            <!-- <el-date-picker
                                v-model="formData.birthday"
                                type="date"
                                placeholder="选择出生日期">
                                </el-date-picker> -->
                        </el-form-item>
                        <el-form-item label="*工作单位" prop="pass">
                            <el-input type="text" v-model="formData.workUnit" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*家庭地址" prop="pass">
                            <el-input type="text" v-model="formData.homeAddress" autocomplete="off"></el-input>
                        </el-form-item>
                        


                        <el-form-item label="申请资料" prop="pass">
                            <el-upload
                            action="https://jsonplaceholder.typicode.com/posts/"
                            list-type="picture-card"
                            :on-change="onChange"
                            :auto-upload="false"
                            >
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button class="sub_btn" @click="submitForm">提交</el-button>
                            <el-button class="cel_btn" @click="cancelShenBao">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div> 
        
    </div>
</template>

<script>
import { checkId, checkPhone } from "../components/common/checkData"
import NavbarHeader from "../components/index/NavbarHeader"
import NewsList from "../components/index/NewsList"
import ImgList from "../components/index/ImgList"
import ActiveList from "../components/index/ActiveList"
import RedSchool from "../components/index/RedSchool"
import DangYuanShow from "../components/index/DangYuanShow"
import FriendLink from "../components/index/FriendLink"
import NavFooter from "../components/common/NavFooter"
import MenuList from "../components/index/MenuList"
import SwiperNews from "../components/index/SwiperNews"
import SwiperImg from "../components/index/SwiperImg"
import ActiveStyle from "../components/index/ActiveStyle"
    export default {
        components: {
            NavbarHeader,
            NewsList,
            ImgList,
            ActiveList,
            RedSchool,
            DangYuanShow,
            FriendLink,
            NavFooter,
            MenuList,
            SwiperNews,
            SwiperImg,
            ActiveStyle
        },
        data() {
            return {
                newsList: [
                    { title: "这是新闻的标题", time: "2020-09-11" },
                    { title: "这是新闻的标题", time: "2020-09-11" },
                    { title: "这是新闻的标题", time: "2020-09-11" },
                ],
                meetingList: [
                    { title: "机关党组八月党员主题活动日", dept: "机关支部委员会", time: "2020-09-11 12:00", position:"金三路", count: 20, status: 1 },
                    { title: "机关党组八月党员主题活动日", dept: "机关支部委员会", time: "2020-09-11 12:00", position:"金三路", count: 20, status: 2 },
                ],
                cateId: 1,
                imgObj: {},
                SwiperList: [],
                TouTiao: [],
                JoinShow: false,
                dialogVisible: false,
                dialogImageUrl: "",
                formData: {
                    idNumber: "",
                    birthday: "",
                },
                mz: [],
                xue: [],
                sexList: [{ name: "男", value: '0' }, { name: "女", value: '1' }],
                imgList: [],
                AllDeptList: [],
                deptId: null,
            }
        },
        computed: {
            idNumber () {
                return this.formData.idNumber
            },
        },
        watch: {
            idNumber () {
                // console.log( this.idNumber )
                if ( this.idNumber && this.idNumber.length == 18 ) {
                    let year = this.idNumber.substr(6,4)
                    let month = this.idNumber.substr(10,2)
                    let day = this.idNumber.substr(12,2)
                    this.formData.birthday = `${year}-${month}-${day}`
                }
            }
        },
        mounted () {
            // this.getImgList()
            // this.getSwiperList()
            // this.getMinZu()
            // this.getXueList()
            // this.getDeptList()
            this.getTouTiao()
        },
        methods: {
             // 组织变化
            deptChange ( e ) {
                console.log( e )
                this.DeptList = []
                this.AllDeptList.forEach( (el, index) => {
                    if ( el.deptId == e ) {
                        this.DeptList.push( el )
                        this.activeIndex = index
                    }
                })
                
            },

            // 获取组织列表
            async getDeptList () {
                let res = await this.$axios.post("/lencon/pc/maps/dept_list")
                if ( res.data.code == 1 ) {
                    this.DeptList = res.data.data
                    this.AllDeptList = res.data.data
                    // console.log( this.AllDeptList )
                }
            },
            // 获取图片
            async getImgList() {
                let res = await this.$axios.post("/lencon/pc/index/banner", { type: 20 })
                if ( res.data.code == 1 ) {
                    let arr = res.data.res
                    this.imgObj = arr[0]
                }
            },
            // 获取轮播与头条
            async getSwiperList() {
                let res = await this.$axios.post("/lencon/pc/index/lunbo", { cate_id: 2 })
                if ( res.data.code == 1 ) {
                    this.SwiperList = res.data.res 
                    this.TouTiao = res.data.toutiaoArray
                }
            },
            // 获取头条
            async getTouTiao() {
                let res = await this.$axios.post("/lencon/pc/index/index_news_list", { is_head: 1, page:1, pageSize: 10 })
                if ( res.data.code == 1 ) {
                    this.TouTiao = res.data.res
                }
            },
            // 入党申请
            getShow ( bool ) {
                console.log( bool )
                this.JoinShow = bool
                
            },
            // 关闭dialog
            cancelShenBao () {
                this.JoinShow = false
            },
            // 上传图片变化
            async onChange ( files ) {
                console.log( files )
                let filePath = files.raw 
                let FD = new FormData()
                FD.append('circle', filePath)
                FD.append("file_name", "circle")
                let res = await this.$axios.post("/lencon/app/common/upload", FD)
                if ( res.data.code == 1 ) {
                    this.imgList.push( res.data.data[0] )
                }
            },

            // 获取民族
            async getMinZu () {
                let res = await this.$axios.post("/lencon/pc/common/mzLists")
                if ( res.data.code == 1 ) {
                    this.mz = res.data.res
                }
            },
            // x获取学历列表
            async getXueList () {
                let res = await this.$axios.post("/lencon/pc/common/dataList", { type: "education_types" })
                if ( res.data.code == 1 ) {
                    this.xue = res.data.res
                }
            },
            // 提交入党资料
            async submitForm () {
                this.formData.acceptDeptId = Number( this.deptId  )
                this.formData.phone = String( this.formData.phone )
                this.formData.minZu = String( this.formData.minZu )
                if ( this.imgList.length ) {
                    this.formData.material = this.imgList.join(",")
                } else {
                    this.formData.material = ""
                }
                let { acceptDeptId, userName, sex, xueLi, minZu, phone, idNumber,birthday,workUnit,homeAddress } = this.formData
                let isMatch = checkId( idNumber )
                let isPhone = checkPhone( phone )
                console.log( isMatch )
                if ( !acceptDeptId ) {
                    return this.$message.error("请选择党组织")
                } else if ( !userName ) {
                    return this.$message.error("请输入你的姓名")
                } else if ( !sex ) {
                    return this.$message.error("请选择你的性别")
                } else if ( !xueLi ) {
                    return this.$message.error("请选择你的学历")
                } else if ( !isPhone ) {
                    return this.$message.error("你输入的手机号码格式有误")
                } else if ( !minZu ) {
                    return this.$message.error("请选择你的民族")
                } else if ( !isMatch ) {
                    return this.$message.error("你输入的身份证格式有误")
                } else if ( !birthday ) {
                    return this.$message.error("请选择你的出生日期")
                }  else if ( !workUnit ) {
                    return this.$message.error("请输入你的工作单位")
                }  else if ( !homeAddress ) {
                    return this.$message.error("请输入你的家庭单位")
                } else {
                    let res = await this.$axios.post("/lencon/pc/deve/rudang", this.formData )
                    if ( res.data.code == 1 ) {
                        this.$message.success( res.data.msg )
                        this.JoinShow = false
                    }
                }
            },
        },
    }
</script>
<style>
.el-dialog__wrapper {
    z-index: 100000000 !important;
}
.el-select-dropdown  {
    z-index: 100000000000000000000000 !important;
}
.el-picker-panel {
    z-index: 100000000000000000000000 !important;
}
</style>

<style lang="scss" scoped>
.index {
    width: 100%;
    &::-webkit-scrollbar {
        display: none;
    }
}
.OverFlow {
    height: 100%;
    overflow: hidden;
}
.Scroll {
    height: 100%;
    overflow: scroll;
}
.news_list_box {
    width: 1200px;
    box-sizing: border-box;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
}
.active_list {
    width: 1200px;
    box-sizing: border-box;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
}
.img_box {
    width: 1200px;
    height: 108px;
    margin:  10px auto;
    background-color: #f5f5f5;
    
    img {
        width: 1200px;
        height: 108px;
    }

}
.swiperbox {
    // width: 100%;
    // background: url("../assets/static/index/btm_bg.jpg") bottom left no-repeat;
    // background-size: cover;
    // transform: translateY(-10px);
}
.dialog_model {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.3);
        z-index: 10000000000;
        .dialog_box {
            width: 820px;
            height: 735px;
            overflow-y: scroll;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -410px;
            margin-top: -377px;
            background-color: #fff;
            border-radius: 5px;
            // overflow: hidden;
            padding: 20px;
            .dialog_title {
                font-size: 24px;
                font-weight: bold;
                padding-bottom: 20px;
                border-bottom: 2px solid #2767c4 ;
                color: #2767c4 ;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .form_box {
                padding: 20px 0;
                .sub_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #2767c4 ;
                }
                .cel_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #b3b3b3;
                }
            }
        }
    }
</style>